export default __webpack_public_path__ + "static/media/weintek.5af58aea.png";